/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState } from 'react';
// import clsx from 'clsx';
import { Modal, Text, Eyebrow, Icon, Link, size, TextComponent, Types } from '@marriott/mi-ui-library';
// import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { decodeHtml } from '../../utils/OfferUtils';
import { EXTERNAL_CTA_TYPE, INTERNAL_CTA_TYPE } from '../../constants/CommonConstants';
import { OffersDetailsCardProps, TermsAndConditionsModalProps, tncDataProps } from './OffersDetailsCard.types';

export const TermsAndConditionsModal: FC<TermsAndConditionsModalProps> = props => {
  return (
    <Modal show={true} role={'dialog'} aria-label={props?.labelledBy} modalId={props?.labelledBy}>
      <Modal.Header
        labelText={props?.labelText}
        popupHeaderOnCLoseFunc={(event: any) => props?.toggleModal(event)}
        className="terms-modal-header"
      />
      <Modal.Body>
        <div className="offers-terms-details" tabIndex={0} role="dialog" aria-label={props?.labelledBy}>
          <Text
            fontSize={Types.size.medium}
            customClass={'offers-additional-terms'}
            element={Types.tags.paragraph}
            dangerouslySetInnerHTML={{
              __html: ` ${props?.details !== null ? decodeHtml(props?.details) : ''}`,
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const OffersDetailsCardWrapper: FC<OffersDetailsCardProps> = props => {
  const offersData: any = props?.offersData?.responseObject?.offers?.[0];
  const componentId = props?.model?.componentId;
  const trackingProperties = props?.model?.trackingProperties;
  // const { envVarsObject } = useClientEnvVarsStore();
  // const imageDomain = envVarsObject?.['UXL_IMAGE_CACHE_DOMAIN'] ?? IMAGE_CACHE_DOMAIN;
  // const logoImageSrc = offersData?.media?.secondaryImage?.imageSrc
  //   ? imageDomain + offersData.media.secondaryImage.imageSrc
  //   : '';

  const [openModalIndex, setOpenModalIndex] = useState<number | null>(null);
  const toggleModal = (event: React.MouseEvent, index: number | null) => {
    // When modal is open user will not able to scroll the page.
    const body = document.querySelector('body');
    if (body) {
      if (index !== null) {
        event.preventDefault();
        body.style.overflow = 'hidden';
        body.style.paddingRight = `15px`;
      } else {
        body.style.overflow = '';
        body.style.paddingRight = '';
      }
    }
    setOpenModalIndex(prev => (prev === index ? null : index));
  };

  const getTnCData = (tncCta: tncDataProps[]) => {
    const validLinks =
      tncCta?.filter(tncData => {
        if (!tncData?.label) return false;
        if (tncData?.extInd && !tncData?.link) return false;
        return true;
      }) || [];
    return (
      <div className="d-flex link-wrapper">
        {validLinks.map((tncData, index) => {
          const isExternal = !!tncData?.extInd;
          return (
            <React.Fragment key={tncData?.label + index}>
              {index > 0 && <div className="link-divider" />}
              <span className="d-flex align-items-center">
                <Link
                  text={tncData?.label}
                  ariaLabel={`${tncData?.label}-${index}-link`}
                  linkClassName={`${isExternal ? 'm-link-tertiary-button-external' : 'm-link'}`}
                  linkHref={isExternal ? tncData.link : '#'}
                  target={isExternal ? '_blank' : '_self'}
                  linkType={isExternal ? 'external' : 'internal'}
                  trackingProperties={trackingProperties}
                  custom_click_track_value={`${trackingProperties?.cardLocation}|${tncData.label}|${
                    isExternal ? EXTERNAL_CTA_TYPE : INTERNAL_CTA_TYPE
                  }`}
                  callback={
                    !isExternal && tncData?.details
                      ? event => {
                          event.preventDefault();
                          toggleModal(event, index);
                        }
                      : undefined
                  }
                />
                {!isExternal && tncData?.details && openModalIndex === index && (
                  <TermsAndConditionsModal
                    labelText={tncData?.label}
                    details={tncData?.details}
                    toggleModal={(event: React.MouseEvent) => toggleModal(event, null)}
                    labelledBy={`${tncData?.label}-${index}-link`}
                  />
                )}
              </span>
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  return (
    <div className="offerDetails-container container">
      {/* Use Case 1 : with card art image. To be uncommented for 11.2 or later  */}
      {/* {
      logoImageSrc ? 
      ( */}
      {/* <div className="content-wrapper">
          <div className="d-flex">
            <div className="credit-card-container"> */}
      {/* Commenting Badge atom, Can be used once API has data for this atom */}
      {/* <Badge
                badgeVariation={Types.BadgeVariation.Overlay}
                badgeText={'NO ANNUAL FEE'}
                badgeIcon={'icon-lock'}
              /> */}
      {/* <Image
                title={offersData?.media?.secondaryImage?.title}
                customClass="logo-image"
                loading="eager"
                defaultImageURL={logoImageSrc}
                altText={offersData?.media?.secondaryImage?.alternateDescription}
                dynamic={false}
              ></Image>
            </div>
          </div>

          <TextComponent
            contentAlignment="left"
            header={offersData?.detailsTitle}
            componentId={componentId}
            headerFontSize={size.medium}
            styleclass={'p-0 text-details mb-2'}
            customClass="text-block"
            descriptionText={offersData?.descriptionBody1}
            showLessDesc={false}
            descriptionFontSize={size.medium}
          />
          {offersData?.tncCta?.length > 0 && getTnCData(offersData?.tncCta)}
          {offersData?.ctaLabel !== null && offersData?.ctaLabel !== undefined && offersData?.ctaLabel !== '' && (
            <Button
              isLink={offersData?.ctaLink ? true : false}
              type={Types.ButtonTypeVariation.Button}
              href={offersData?.ctaLink}
              className={clsx(`m-button-primary mt-4 pt-2`, {
                'm-button-external': offersData?.ctaExtInd,
              })}
              target={offersData?.ctaExtInd ? '_blank' : '_self'}
              trackingProperties={trackingProperties}
              custom_click_track_value={`${trackingProperties?.cardLocation}|${offersData?.ctaLabel}|${
                offersData?.ctaExtInd ? EXTERNAL_CTA_TYPE : INTERNAL_CTA_TYPE
              }`}
            >
              {offersData?.ctaLabel}
            </Button>
          )}
        </div>
      ) : ( */}
      {/* Use Case 2 : without card art image */}
      <div className="content-wrapper">
        <TextComponent
          contentAlignment="left"
          header={offersData?.detailsTitle}
          componentId={componentId}
          headerFontSize={size.small}
          styleclass={'p-0 text-title'}
          descriptionText={offersData?.descriptionBody1}
          showLessDesc={false}
          descriptionFontSize={size.small}
        />
        <TextComponent
          contentAlignment="left"
          subHeader={offersData?.detailsSubTitle}
          componentId={componentId}
          subHeaderFontSize={size.medium}
          styleclass={'p-0 text-sub-details '}
          descriptionText={offersData?.descriptionBody2}
          showLessDesc={false}
          descriptionFontSize={size.small}
        />
        {offersData?.tncCta?.length > 0 && getTnCData(offersData?.tncCta)}
      </div>
      {/* )} */}

      <div className="listItem-wrapper">
        <div className="list-container">
          <div className="mb-3">
            <Eyebrow text={offersData?.bulletsTitle} />
          </div>
          {offersData?.needToKnowBullets?.length > 0 &&
            offersData?.needToKnowBullets?.map((bullet: any, idx: number) => {
              return (
                bullet?.text !== null &&
                bullet?.text !== undefined &&
                bullet?.text?.length > 0 && (
                  <div className="bullet-points" key={bullet?.text + idx}>
                    <div className="col p-0 m-icon-text">
                      <Icon iconClass={`${bullet?.icon} icon-s`}></Icon>
                      <span className="t-font-s">{bullet?.text}</span>
                    </div>
                  </div>
                )
              );
            })}
        </div>
      </div>
    </div>
  );
};
